import { states } from 'utils';

import { SelectField, TextField } from './fields';
import { AddressValues } from './onboarding-model';

const STATE_OPTIONS = states.map((state) => ({ value: state.abbreviation, label: state.name }));

/** Street, street 2, city, state and zip; `required` marks the four Fidelity needs. */
export const AddressFields = ({
    label,
    value,
    onChange,
    required,
    disabled,
}: {
    label: string;
    value: AddressValues;
    onChange: (value: AddressValues) => void;
    required?: boolean;
    disabled?: boolean;
}) => {
    const set = (key: keyof AddressValues) => (next: string) => onChange({ ...value, [key]: next });
    return (
        // One line: street widest, then apt, city, state and zip
        <div className="col-span-full grid grid-cols-[minmax(0,2fr)_minmax(0,1fr)_minmax(0,1.4fr)_minmax(0,1fr)_minmax(0,0.8fr)] items-start gap-x-5 gap-y-4">
            <TextField
                label={label}
                value={value.street}
                onChange={set('street')}
                required={required}
                disabled={disabled}
            />
            <TextField label="Apt, suite" value={value.street2} onChange={set('street2')} disabled={disabled} />
            <TextField label="City" value={value.city} onChange={set('city')} required={required} disabled={disabled} />
            <SelectField
                label="State"
                value={value.state}
                onChange={set('state')}
                options={STATE_OPTIONS}
                required={required}
                disabled={disabled}
            />
            <TextField
                label="Zip"
                value={value.postalCode}
                onChange={set('postalCode')}
                required={required}
                disabled={disabled}
            />
        </div>
    );
};
